function releaseNaverMap ({ marker, onError }) {
  try {
    if (marker && typeof marker.setMap === 'function') {
      marker.setMap(null)
    }
  } catch (error) {
    if (typeof onError === 'function') {
      onError(error)
    }
  }
}

module.exports = {
  releaseNaverMap,
}
